export default __webpack_public_path__ + "static/startup-program-38b4ef2bbad1b9d2df2f33df6282afc1.svg";